import React from 'react';
import './Specialiproc.css';

const Specialiproc = () => {
  return (
    <div className="specialiproc-container">
      <h2>FEATURES <strong>-</strong></h2>
      <ul>
        <li>
          <strong>Specialized PVC Process</strong> – Standard TECHMATION control system The control procedure is specially designed for PVC fitting.
        </li>
        <li>
          <strong>Widened Door</strong> – Widened safe door makes easier for removal of PVC fitting.
        </li>
        <li>
          <strong>PVC Screw</strong> – Specialized PVC Screw solves the problems of drawing and yellowing of PVC products effectively.
        </li>
        <li>
          <strong>Air Cooling</strong> – Excellent air cooling control improves the stability of PVC heat-sensitivity molding process.
        </li>
        <li>
          <strong>Plasticization Precision</strong> – The charge adopts high torque and low speed motor, which improves the plasticization precision.
        </li>
        <li>
          <strong>Servo & Variable Drives</strong> – Servo and Variable pump are available according to every production condition.
        </li>
        <li>
          <strong>Core Pulling</strong> – Standard two sets of core pulling; more sets of core pulling are available.
        </li>
        <li>
          <strong>Temperature Control</strong> – Solid state relays for temperature control are used to ensure that the barrel temperature is controlled within a reasonable range.
        </li>
      </ul>
    </div>
  );
};

export default Specialiproc;
